<div class="row">
  <div class="col-12">
    <div *ngIf="resultAction">
      <h4>Remuneraciones</h4>
      <table class="table border-bottom mb-4">
        <tbody>
          <tr>
            <td class="fs-5"><strong>Total acción {{resultAction.Title}}</strong></td>
            <td class="text-end fs-5"><strong>{{resultAction.TotalRemuneration | currency:'EUR'}}</strong></td>
          </tr>
        </tbody>
      </table>
      <table class="table table-striped table__resume">
        <thead>
          <tr>
            <th>Total subacciones</th>
            <th class="text-center">Unidades vendidas</th>
            <th class="text-end">Remuneración</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let subaction of resultAction.Subactions">
            <td>{{subaction.Title}}</td>
            <td class="text-center">{{subaction.TotalUnits}}</td>
            <td class="text-end">{{subaction.TotalRemuneration | currency:'EUR'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>